import { render, staticRenderFns } from "./closedTaskItem.vue?vue&type=template&id=7d893c82&"
import script from "./closedTaskItem.vue?vue&type=script&lang=js&"
export * from "./closedTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports